import _fails from "../internals/fails";
var exports = {};
var fails = _fails;

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ""[METHOD_NAME]("\"");
    return test !== test.toLowerCase() || test.split("\"").length > 3;
  });
};
export default exports;